import React, { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import withLayout from "../layout";
import SearchForm from "../rent/SearchForm";
import RentHeader, { RentFooter } from "../rent/RentHeader";
import { Icons, QrGraphic } from "../rent/ui";
import { buildPlate } from "../booking";
import "./login.css";

// Startseite: zwei Einstiege – im Voraus buchen oder vor Ort bezahlen
const Login = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  const hereRef = useRef(null);
  const codeRef = useRef(null);
  const [plate, setPlate] = useState("");
  const [plateError, setPlateError] = useState(false);
  const isHere = location.pathname === "/vor-ort";

  useEffect(() => {
    document.title = isHere ? "Vor Ort bezahlen | innopark24" : "Parkplatz buchen | innopark24";
    if (isHere && hereRef.current) {
      hereRef.current.scrollIntoView({ behavior: "smooth", block: "start" });
      if (codeRef.current) codeRef.current.focus({ preventScroll: true });
    }
  }, [isHere]);

  const onSearch = (params) => navigate(`/search?${new URLSearchParams(params).toString()}`);

  // Vor Ort bezahlen: nur Kennzeichen eingeben, die Bezahlseite sucht den Parkvorgang
  const openPay = (e) => {
    e.preventDefault();
    const p = buildPlate(plate, "de") || buildPlate(plate, "int");
    if (!p) {
      setPlateError(true);
      return;
    }
    navigate(`/pay?plate=${encodeURIComponent(p)}`);
  };

  const feats = [
    ["plate", false],
    ["night", true],
    ["card", false],
    ["gate", false],
  ];

  return (
    <div className="rp">
      <RentHeader />
      <main className="rp-main">
        <div className="rx-hero">
          <section className="rx-card rx-entry">
            <span className="rx-eyebrow">{t("rxBookEyebrow")}</span>
            <h1>{t("rxBookHead")}</h1>
            <p className="rx-muted">{t("rxBookLead")}</p>
            <SearchForm onSearch={onSearch} />
          </section>

          <section className="rx-card rx-entry rx-here" id="vor-ort" ref={hereRef}>
            <span className="rx-eyebrow">{t("rxHereEyebrow")}</span>
            <h2>{t("rxHereHead")}</h2>
            <p>{t("rxHereLead")}</p>
            <div className="rx-qr">
              <div className="rx-qr-box">
                <QrGraphic />
              </div>
              <div>
                <b>{t("rxQrHead")}</b>
                <p>{t("rxQrText")}</p>
              </div>
            </div>
            <form onSubmit={openPay} noValidate>
              <div className={`ipl-field ${plateError ? "has-error" : ""}`}>
                <label htmlFor="rx-plate">{t("rxPlateLabel")}</label>
                <div className="rx-code-row">
                  <div className="ipl-input">
                    {Icons.car}
                    <input
                      id="rx-plate"
                      ref={codeRef}
                      type="text"
                      autoComplete="off"
                      autoCapitalize="characters"
                      spellCheck="false"
                      maxLength={14}
                      placeholder="M-AB1234"
                      value={plate}
                      onChange={(e) => {
                        setPlate(e.target.value.toUpperCase().replace(/[^A-ZÄÖÜ0-9\s-]/g, ""));
                        setPlateError(false);
                      }}
                    />
                  </div>
                  <button className="ipl-btn" type="submit">
                    <span>{t("rxGo")}</span>
                  </button>
                </div>
                <div className="ipl-err">{t("rpPlateErrorDe")}</div>
              </div>
            </form>
          </section>
        </div>

        <section className="rx-feats" aria-label={t("rxFeatsLabel")}>
          {feats.map(([icon, night], i) => (
            <div className="rx-feat" key={icon}>
              <div className={`rx-ic ${night ? "night" : ""}`}>{Icons[icon]}</div>
              <b>{t(`rxF${i + 1}Head`)}</b>
              <span>{t(`rxF${i + 1}Text`)}</span>
            </div>
          ))}
        </section>
      </main>
      <RentFooter />
    </div>
  );
};

export default withLayout(Login);
